import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import FAQSection from "./components/FAQSection";
import { useFaqData } from "../../lib/useMockData";

export default function FAQ() {
  const { heroData } = useFaqData();
  return (
    <PageLayout>
      <InfoPageHero
        label="FAQ"
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="よくある質問"
      />
      <FAQSection />
      <InfoPageFooter />
    </PageLayout>
  );
}
